import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getTxMatrixList(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-tx-matrix-list.do`, params);
  },
  getTxScatterList(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-tx-scatter-list.do`, params);
  },
  getTxRawList(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-tx-raw-list.do`, params);
  },
  getDetailCallTree(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-detail-call-tree.do`, params);
  },
  getDetailError(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-detail-error.do`, params);
  },
  getDetailEumJsErrorList(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-detail-eum-js-error-list.do`, params);
  },
  getDetailEumAjaxList(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-detail-eum-ajax-list.do`, params);
  },
  getDetailEumNav(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-detail-eum-nav.do`, params);
  },
  getCallTree(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-call-tree.do`, params);
  },
  getTxRawDataExistStatus(params) {
    return axios.post(`${baseUrl}/apm2x/tx/get-exist-tx-status.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/apm/transaction.js